import { doc, getDoc, deleteDoc, updateDoc } from 'firebase/firestore';
import { db } from "../../firebaseConfig";
import { getProductoPorId } from '../productos/productoUtils';
import { getServicioPorId } from '../servicios/serviciosUtils';


// Función para obtener el carrito de un usuario
export const getUserCart = async (uid) => {
    const userCartRef = doc(db, "carritos", uid);
    const userCartSnapshot = await getDoc(userCartRef);
    
    return userCartSnapshot.exists() ? userCartSnapshot.data() : null;
  };


// Función para obtener detalles de productos del carrito
export const obtenerDetallesProductos = async (cartItems) => {
    try {
      const promises = (cartItems.productos || []).map(async (producto) => {
        const detalleProducto = await getProductoPorId(producto.id);
        return {
          ...detalleProducto,
          tipo: "producto",
          cantidad: producto.cantidad, // Mantener la cantidad del producto
        };
      });
      const productos = await Promise.all(promises);
      return productos.filter((p) => p && p.id);
    } catch (error) {
      console.error("Error al obtener detalles de los productos:", error);
      return [];
    }
  };
  
  // Función para obtener detalles de servicios del carrito
  export const obtenerDetallesServicio = async (cartItems) => {
    try {
      const promises = (cartItems.servicios || []).map(async (servicio) => {
        const detalleServicio = await getServicioPorId(servicio.id);
        if (!detalleServicio) return null;
        let servicioActualizado = {
          ...detalleServicio,
          cantidad: servicio.cantidad,
        };
  
        if (detalleServicio.stock) {
          if (detalleServicio.duracion === "unico") {
            servicioActualizado = {
              ...servicioActualizado,
              tipo: "servicio",
              diaSeleccionado: servicio.diaSeleccionado,
              horaInicioSeleccionada: servicio.horaInicioSeleccionada,
            };
          } else {
            servicioActualizado = {
              ...servicioActualizado,
              tipo: "servicio",
              cantidadDuracion: servicio.cantidadDuracion,
              diaSeleccionado: servicio.diaSeleccionado,
              horaInicioSeleccionada: servicio.horaInicioSeleccionada,
            };
          }
        } else {
          if (detalleServicio.duracion === "unico") {
            servicioActualizado = {
              ...servicioActualizado,
              tipo: "servicio",
              diaSeleccionado: servicio.diaSeleccionado,
              horaInicioSeleccionada: servicio.horaInicioSeleccionada,
            };
          } else {
            servicioActualizado = {
              ...servicioActualizado,
              tipo: "servicio",
              cantidadDuracion: servicio.cantidadDuracion,
              diaSeleccionado: servicio.diaSeleccionado,
              horaInicioSeleccionada: servicio.horaInicioSeleccionada,
            };
          }
        }
  
        return servicioActualizado;
      });
  
      const productos = await Promise.all(promises);
      return productos.filter((p) => p && p.id);
    } catch (error) {
      console.error("Error al obtener detalles de los productos:", error);
      return [];
    }
  };

  // Función para eliminar el carrito de un usuario
export const eliminarCarritoUsuario = async (uid) => {
  try {
      const userCartRef = doc(db, "carritos", uid);
      await deleteDoc(userCartRef);
      console.log("Carrito eliminado correctamente");
  } catch (error) {
      console.error("Error al eliminar el carrito:", error);
      throw new Error("Error al eliminar el carrito");
  }
};
  

/**
 * Marca cada artículo del carrito como disponible o no.
 * No disponible = pausado/deshabilitado, o de una tienda inactiva, pausada o baneada,
 * o un producto sin existencias. Agrega `noDisponible` y `motivoNoDisponible`.
 */
export const marcarDisponibilidad = async (items) => {
  const vendedores = [...new Set(items.map((i) => i.vendedorUid).filter(Boolean))];
  const estadoTienda = {};
  await Promise.all(
    vendedores.map(async (uid) => {
      try {
        const snap = await getDoc(doc(db, "tiendas", uid));
        const t = snap.exists() ? snap.data() : null;
        estadoTienda[uid] = !t || (t.activado !== false && !t.pausa && !t.blacklist);
      } catch (error) {
        console.error("Error al revisar la tienda:", error);
        estadoTienda[uid] = true; // si no se pudo leer, el servidor valida al pagar
      }
    })
  );

  return items.map((item) => {
    let motivo = null;
    if (item.pausa || item.deshabilitado || item.eliminado) motivo = "Ya no está disponible";
    else if (item.vendedorUid && estadoTienda[item.vendedorUid] === false) motivo = "La tienda no está activa";
    else if (item.tipo === "producto" && !(item.stock > 0)) motivo = "Agotado";
    return { ...item, noDisponible: !!motivo, motivoNoDisponible: motivo };
  });
};

// Quita del carrito los artículos indicados (productos y servicios)
export const quitarDelCarrito = async (uid, items) => {
  const ref = doc(db, "carritos", uid);
  const snap = await getDoc(ref);
  if (!snap.exists()) return;
  const ids = (tipo) => new Set(items.filter((i) => i.tipo === tipo).map((i) => i.id));
  const prod = ids("producto");
  const serv = ids("servicio");
  const data = snap.data();
  await updateDoc(ref, {
    productos: (data.productos || []).filter((p) => !prod.has(p.id)),
    servicios: (data.servicios || []).filter((s) => !serv.has(s.id)),
  });
};
